import { useState } from "react";
import PropTypes from "prop-types";
import { Alert, Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import Lang from "components/Lang";

const Login = ({ submit, error }) => {
  // const [companyname, setCompanyname] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // const checkSubmittable = () => Boolean(companyname && username && password);
  const checkSubmittable = () => Boolean(username && password);
  const submitHandler = (event) => {
    event.preventDefault();
    if (!checkSubmittable()) {
      return;
    }
    submit(username, password);
  };
  return (
    <Container fluid={true}>
      <Row className="mt-5">
        <Col xs={"12"} sm={{ span: "8", offset: "2" }} md={{ span: "6", offset: "3" }} lg={{ span: "4", offset: "4" }}>
          <h3>ログイン</h3>
          <Card>
            <Card.Body>
              {error && <Alert variant="warning"><Lang>認証に失敗しました</Lang></Alert>}
              <Form onSubmit={submitHandler}>
                {/* <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    value={companyname}
                    placeholder="組織名"
                    onChange={(event) => setCompanyname(event.target.value)}
                  />
                </Form.Group> */}
                <Form.Group className="mb-3">
                  <Lang>{/* TODO placeholder ユーザー名 */}
                    <Form.Control
                      type="text"
                      value={username}
                      placeholder="ユーザー名"
                      onChange={(event) => setUsername(event.target.value)}
                    />
                  </Lang>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Lang>{/* TODO placeholder パスワード */}
                    <Form.Control
                      type="password"
                      value={password}
                      placeholder="パスワード"
                      onChange={(event) => setPassword(event.target.value)}
                    />
                  </Lang>
                </Form.Group>
                <Form.Group className="clearfix">
                  <Button variant="primary" className="float-end" type="submit" disabled={!checkSubmittable()}>
                    <Lang>ログイン</Lang>
                  </Button>
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

Login.propTypes = {
  submit: PropTypes.func.isRequired
};

export default Login;